"use client";

import Image from "next/image";
import styled from "@mui/material/styles/styled";
export default styled(Image)({
  width: "100%",
  height: "auto"
});